import React from 'react'
import {connect} from 'react-redux'
import {wrapDispatch} from 'multireducer'
import LeafTopic from '../components/LeafTopic'
import { withRouter } from 'react-router'
import {addActiveExplanation, makeSelectTopic, makeSelectExplanations, loadNextNExplanations} from '../../../redux/modules/topic'
import {postToggleVote} from '../../../redux/modules/content'
//import {showModal} from '../../../redux/modules/modal'
import {selectUserInfo} from '../../../redux/modules/session'
import {toJS} from '../../../util/ToJS'
import SubjectToCSSName from '../../../core/less/SubjectToCSSName'
import qs from 'query-string'
import {showModal} from '../../../redux/modules/modal'

function getScrollXY() {
  var scrOfX = 0, scrOfY = 0
  if ( typeof( window.pageYOffset ) === 'number' ) {``
    //Netscape compliant
    scrOfY = window.pageYOffset
    scrOfX = window.pageXOffset
  } else if ( document.body && ( document.body.scrollLeft || document.body.scrollTop ) ) {
    //DOM compliant
    scrOfY = document.body.scrollTop
    scrOfX = document.body.scrollLeft
  } else if ( document.documentElement && ( document.documentElement.scrollLeft || document.documentElement.scrollTop ) ) {
    //IE6 standards compliant mode
    scrOfY = document.documentElement.scrollTop
    scrOfX = document.documentElement.scrollLeft
  }
  return [ scrOfX, scrOfY ]
}

//taken from http://james.padolsey.com/javascript/get-document-height-cross-browser/
function getDocHeight() {
  var D = document
  return Math.max(
    D.body.scrollHeight, D.documentElement.scrollHeight,
    D.body.offsetHeight, D.documentElement.offsetHeight,
    D.body.clientHeight, D.documentElement.clientHeight
  )
}

class VisibleLeafTopicComponent extends React.PureComponent {
  mobileBreakPoint = 825; // corresponds with xs breakpoint in css

  constructor(props) {
    super(props)
    this.handleWindowResize = this.handleWindowResize.bind(this)
    this.loadMore = this.loadMore.bind(this)
    this.scrollEvents = [
      'scroll',
      'wheel',
      'DOMMouseScroll',
      'MozMousePixelScroll',
      'touchstart',
      'touchmove',
      'touchend'
    ]
    this.scrollAdjust = 500 //How far from the bottom should we be before we load the next explanations

    this.state = {
      width: window.innerWidth,
    }
  }

  componentDidMount() {
    for (let e of this.scrollEvents) {
      document.addEventListener(e, this.loadMore, false)
    }
    
    window.addEventListener('resize', this.handleWindowResize)

    // const surveyTopics = new Set([
    //   10316, 10350, 10315, 4335, 4361, 10272, 9143, 9138  
    // ])

    // const topicId = this.props.topic.id


    // if (surveyTopics.has(topicId)) {
    //   this.props.launchSurveyModal()
    // }

 
  }

  componentWillUnmount() {
    for (let e of this.scrollEvents) {
      document.removeEventListener(e, this.loadMore, false)
    }
    window.removeEventListener('resize', this.handleWindowResize)
  }

  handleWindowResize() {
    this.setState({ width: window. innerWidth})
  }

  loadMore() {
    const {loadNextNExplanations} = this.props
    if (getDocHeight() <= getScrollXY()[1] + window.innerHeight + this.scrollAdjust) {
      loadNextNExplanations()
    }
  }

  render() {
    const {topic, explanationId, ...rest} = this.props
    let colorSubject = false
    if (topic.breadcrumbs.length) {
      colorSubject = SubjectToCSSName[topic.breadcrumbs[0].id]
    }
    return (
      <LeafTopic
        colorSubject={colorSubject}
        explanationId={explanationId}
        isMobile={window.innerWidth <= this.mobileBreakPoint}
        {...rest}
      />
    )
  }
}

const makeMapStateToProps = () => {
  const selectTopic = makeSelectTopic()
  const selectExplanations = makeSelectExplanations(selectTopic)
  const mapStateToProps = state => {
    const userInfo = selectUserInfo(state)
    const explanations = selectExplanations(state)
    return {
      isLoggedIn: userInfo.isLoggedIn,
      isModerator: (userInfo.role == 'mod' || userInfo.role == 'admin'),
      topicId: state.getIn(['topic','topic']),
      explanations: explanations,
      activeExplanationIds: state.getIn(['topic','activeExplanationIds'])
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = (dispatch,{history, location}) => {
  return {
    addActiveExplanation: (explanationId, withHistory=true) => {
      if (withHistory) {
        const query = {
          id: explanationId,
          type: 'explanation'
        }
        history.replace({
          search: qs.stringify(query),
          state: {
            noScrollRestoration: true
          }
        })
      }
      dispatch(addActiveExplanation(explanationId))
    },
    toggleVote: (type,id) => wrapDispatch(dispatch, 'leafExplanation')(postToggleVote(type,id)),
    loadNextNExplanations: () => dispatch(loadNextNExplanations()),
    launchSurveyModal:() => dispatch(showModal('SURVEY_MODAL', {}))
  }
}

const VisibleLeafTopic = withRouter(connect(
  makeMapStateToProps,
  mapDispatchToProps,
)(toJS(VisibleLeafTopicComponent)))

export default VisibleLeafTopic



// WEBPACK FOOTER //
// ./src/domains/topic/containers/VisibleLeafTopic.js